import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import HomePage from "./pages/HomePage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import AboutPage from "./pages/AboutPage";
import ReferencesPage from "./pages/ReferencesPage";
import ContactPage from "./pages/ContactPage";
import NotFoundPage from "./pages/NotFoundPage";
import ForbiddenPage from "./pages/ForbiddenPage";

export default function App() {
  return (
    <>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-[#f8f7f4] text-[#16181b] font-sans antialiased">
        <Header />
        
        <main className="flex-1">
          <Routes>
            {/* Main Routes */}
            <Route path="/" element={<HomePage />} />
            
            {/* Direct Service Slug Routes (1:1 URL Structure from Scrape) */}
            <Route path="/tilbygning" element={<ServiceDetailPage defaultSlug="tilbygning" />} />
            <Route path="/nybyggeri" element={<ServiceDetailPage defaultSlug="nybyggeri" />} />
            <Route path="/renovering" element={<ServiceDetailPage defaultSlug="renovering" />} />
            <Route path="/tagarbejde" element={<ServiceDetailPage defaultSlug="tagarbejde" />} />
            <Route path="/vinduer-doere" element={<ServiceDetailPage defaultSlug="vinduer-doere" />} />
            <Route path="/terrasser" element={<ServiceDetailPage defaultSlug="terrasser" />} />
            <Route path="/snedkerarbejde" element={<ServiceDetailPage defaultSlug="snedkerarbejde" />} />
            <Route path="/isolering" element={<ServiceDetailPage defaultSlug="isolering" />} />
            
            {/* Catch-all Ydelser Routes */}
            <Route path="/ydelser" element={<ServiceDetailPage defaultSlug="tilbygning" />} />
            <Route path="/ydelser/:slug" element={<ServiceDetailPage />} />

            {/* Main Information Routes */}
            <Route path="/om-os" element={<AboutPage />} />
            <Route path="/referencer" element={<ReferencesPage />} />
            <Route path="/kontakt" element={<ContactPage />} />

            {/* Special Error Pages */}
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </>
  );
}
